/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

export enum CanvasOpAndroid {
  CLIP_RECT = 0,
  DRAW_COLOR = 1,
  DRAW_PAINT = 2,
  DRAW_VIEW = 3,
  DRAW_BITMAP_POS = 4,
  DRAW_BITMAP_RECT = 5,
  DRAW_PATCH = 6,
  DRAW_TEXT = 7,
  DRAW_PATH = 8,
  DRAW_RECT = 9,
  DRAW_ROUND_RECT = 10,
  DRAW_LINE = 11,
  DRAW_CIRCLE = 12,
  DRAW_OVAL = 13,
  DRAW_ARC = 14,
  SAVE = 15,
  SAVE_LAYER = 16,
  SAVE_LAYER_ALPHA = 17,
  RESTORE = 18,
  RESTORE_TO_COUNT = 19,
  SCALE = 20,
  TRANSLATE = 21,
  SKEW = 22,
  ROTATE = 23,
  CONCAT_MATRIX = 24,
  SET_MATRIX = 25,
  DRAW_CHILD = 26,
  WARNING = 27,
  CLIP_PATH = 28,
}
